import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgXx = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="flag-icons-xx"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#fff"
      fillRule="evenodd"
      stroke="#adb5bd"
      strokeWidth={1.1}
      d="M.5.5h638.9v478.9H.5z"
    />
    <path
      fill="none"
      stroke="#adb5bd"
      strokeWidth={1.1}
      d="m.5.5 639 479m0-479-639 479"
    />
  </svg>
);
export default SvgXx;
